import script from "./SavedTreesListWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./SavedTreesListWidget.vue?vue&type=script&setup=true&lang=js"

import "./SavedTreesListWidget.vue?vue&type=style&index=0&id=7ddede7a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ddede7a"]])

export default __exports__